import {
  FaTachometerAlt,
  FaHome,
  FaCalendarPlus,
  FaBoxes,
  FaClipboardList,
  FaUmbrellaBeach,
  FaHotel,
  FaUsers,
  FaEnvelope,
  FaCalendarCheck,
  FaDollarSign,
  FaReceipt,
  FaMoneyBillWave,
  FaFileInvoiceDollar,
  FaFileInvoice,
  FaCog,
  FaBook,
  FaHistory,
  FaCoins,
  FaChartLine,
  FaStar,
  FaQrcode,
  FaTags,
  FaGlobe,
  FaSearch,
  FaChartPie,
  FaConciergeBell,
  FaUserTie,
  FaUtensils,
  FaNewspaper,
  FaUserFriends,
} from "react-icons/fa";

// Single source of truth for the sidebar. Each item is shown only if the
// logged-in user's permissions (from /auth/login) include requiredPermission
// — see PermissionService on the backend for the role -> permission map.
const MENU_CONFIG = [
  { label: "Occupancy", path: "/admin/dashboard", icon: FaTachometerAlt, requiredPermission: "view_occupancy" },
  { label: "Dashboard", path: "/user/dashboard", icon: FaHome, requiredPermission: "view_user_dashboard" },
  { label: "Create Booking", path: "/user/create-booking", icon: FaCalendarPlus, requiredPermission: "create_booking" },
  { label: "Inventory", path: "/user/inventory", icon: FaBoxes, requiredPermission: "view_inventory" },
  { label: "Bookings", path: "/admin/bookings", icon: FaBook, requiredPermission: "view_admin_bookings" },
  { label: "Reviews", path: "/admin/reviews", icon: FaStar, requiredPermission: "view_reviews" },
  { label: "Frequent Guests", path: "/admin/frequent-guests", icon: FaUserFriends, requiredPermission: "view_frequent_guests" },
  { label: "Performance", path: "/admin/performance", icon: FaChartLine, requiredPermission: "view_performance" },
  {
    label: "Daily Entry",
    path: "/user/daily-entries",
    icon: FaClipboardList,
    requiredPermission: "view_daily_entry",
    activePaths: ["/user/daily-entries", "/user/record-daily-entry"],
  },
  { label: "Attendance & Leave", path: "/user/user-leave", icon: FaUmbrellaBeach, requiredPermission: "view_leave_portal" },
  { label: "My Salary", path: "/user/salary", icon: FaCoins, requiredPermission: "view_salary" },
  { label: "Resorts", path: "/admin/resorts", icon: FaHotel, requiredPermission: "manage_resorts" },
  { label: "Rate Management", path: "/admin/rate-management", icon: FaTags, requiredPermission: "manage_resorts" },
  { label: "Website Content", path: "/admin/website-content", icon: FaGlobe, requiredPermission: "manage_website_content" },
  { label: "SEO Settings", path: "/admin/seo", icon: FaSearch, requiredPermission: "manage_seo" },
  { label: "Blog", path: "/admin/blog", icon: FaNewspaper, requiredPermission: "manage_blog" },
  { label: "Users", path: "/admin/users", icon: FaUsers, requiredPermission: "manage_users" },
  // Ground/on-site staff with no login (housekeeping, cooks, drivers etc.) -
  // a separate roster from Users above, which is for logged-in employees.
  // TEMPORARY (2026-11-03): hidden for this prod deploy per explicit
  // request - feature not ready to show on the live UI yet. Uncomment to
  // re-enable.
  // { label: "Staff Management", path: "/admin/staff-management", icon: FaUserTie, requiredPermission: "manage_staff" },
  // Standing menu/prices for the Food Order action on a checked-in booking
  // (see UserInventory.jsx) - ADMIN/PROPERTY_MANAGER/RECEPTION only.
  { label: "Food Menu", path: "/admin/food-menu", icon: FaUtensils, requiredPermission: "manage_food_orders" },
  { label: "Enquiries", path: "/admin/enquiries", icon: FaEnvelope, requiredPermission: "view_enquiries" },
  // Covers Attendance + Leave (gated on manage_leaves) + Salary (the Salary
  // tab inside additionally gates itself on manage_salary via hasPermission -
  // see TeamAttendanceLeave.jsx). Only SUPER_ADMIN has both permissions today,
  // so this single menu gate doesn't over-expose Salary to SUPER_USER, who
  // has manage_leaves but not manage_salary.
  { label: "Workforce", path: "/admin/leaves", icon: FaCalendarCheck, requiredPermission: "manage_leaves" },
  { label: "Pending Actions", path: "/admin/pending-actions", icon: FaConciergeBell, requiredPermission: "view_front_desk_queue" },
  { label: "Revenue", path: "/admin/revenue", icon: FaDollarSign, requiredPermission: "view_revenue" },
  { label: "Expenses", path: "/admin/expenses", icon: FaReceipt, requiredPermission: "view_expenses" },
  {
    label: "Food Collection",
    path: "/admin/food-collection-expenses",
    icon: FaMoneyBillWave,
    requiredPermission: "view_property_collection",
  },
  { label: "Monthly Settlement", path: "/admin/monthly-settlement", icon: FaFileInvoiceDollar, requiredPermission: "view_monthly_settlement" },
  // Cross-property rollup - broader audience than Monthly Settlement above
  // (also visible to a PROPERTY_MANAGER-scoped B2B partner, naturally
  // collapsed to just their own resort via resort-scoping) - see
  // SettlementController.collectionsOverview.
  { label: "Collections Overview", path: "/admin/collections-overview", icon: FaChartPie, requiredPermission: "view_collections_overview" },
  { label: "Audit Log", path: "/admin/audit-log", icon: FaHistory, requiredPermission: "view_audit_log" },
  { label: "GST Invoice", path: "/user/gst-invoice", icon: FaFileInvoice, requiredPermission: "generate_gst_invoice" },
  { label: "Settings", path: "/admin/settings", icon: FaCog, requiredPermission: "manage_company_settings" },
  { label: "QR Codes", path: "/admin/qr-codes", icon: FaQrcode, requiredPermission: "manage_qr_codes" },
];

export default MENU_CONFIG;
